"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkIcons = void 0;
var NetworkIcons;
(function (NetworkIcons) {
    NetworkIcons["xrpl"] = "/assets/chains/xrpl/info/logo.png";
    NetworkIcons["xevm"] = "/assets/chains/xevm/info/logo.jpg";
    NetworkIcons["xahau"] = "/assets/chains/xahau/info/logo.jpg";
})(NetworkIcons || (exports.NetworkIcons = NetworkIcons = {}));
//# sourceMappingURL=icons.js.map